module.exports = __webpack_public_path__ + "f467f70ca1c1ceaa958431336cf26605.svg";